export const TIMESHEET_PERMISSION = {
  EDIT_TIMESHEET: 'urn:replicon:timesheet-action:edit-timesheet'
};
